import { useNavigate } from "react-router-dom";
import { useLocalization } from "../../context/LocalizationContext";
import getUserRoleFromJWT from "../../shared/helpers/getUserRoleFromJWT";
import { UserRole } from "../../shared/Enums/UserRole";

const ClosedPage = () => {
  const navigate = useNavigate();
  const { t: localization } = useLocalization();

  return (
    <div className="closed-page-container">
      <div className="tick-animation">
        <svg width="120" height="120" viewBox="0 0 120 120">
          <circle
            cx="60"
            cy="60"
            r="55"
            fill="#eafaf1"
            stroke="#28a745"
            strokeWidth="5"
          />
          <polyline
            points="40,65 55,80 85,50"
            fill="none"
            stroke="#28a745"
            strokeWidth="8"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="tick"
          />
        </svg>
      </div>
      <h2 className="closed-title">{localization("service_closed_success")}</h2>
      <button
        className="btn btn-blue btn-sm"
        onClick={() => {
          const userRole = getUserRoleFromJWT();
          navigate(
            userRole === UserRole.DEALER_ADMIN
              ? "/admin-dashboard"
              : "/service-desk-dashboard",
          );
        }}
      >
        {localization("go_to_dashboard")}
      </button>
    </div>
  );
};

export default ClosedPage;
